// Defensive JSON parsing for LLM responses (per CLAUDE.md LLM integration rules):
// strip markdown code fences first, then fall back to extracting the first {...}
// block before JSON.parse. Returns the parsed object, or null if nothing parses.
export function parseLlmJson(raw) {
  if (raw == null) return null;
  let text = String(raw).trim();

  // Strip ``` / ```json fences if present.
  if (text.startsWith('```')) {
    text = text.replace(/^```[a-zA-Z]*\n?/, '').replace(/```\s*$/, '').trim();
  }

  try {
    return JSON.parse(text);
  } catch (_) {
    // fall through to block extraction
  }

  const match = text.match(/\{[\s\S]*\}/);
  if (match) {
    try {
      return JSON.parse(match[0]);
    } catch (_) {
      return null;
    }
  }
  return null;
}
